/** 协议 §5.7 remote_popup 弹窗类型 */

export type RemotePopupType = 'pa_switch' | 'update' | 'update_progress' | 'restart';

const REMOTE_POPUP_TYPES: RemotePopupType[] = [
  'pa_switch',
  'update',
  'update_progress',
  'restart',
];

export function isRemotePopupType(value: unknown): value is RemotePopupType {
  return typeof value === 'string' && REMOTE_POPUP_TYPES.includes(value as RemotePopupType);
}

export function defaultRemotePopupType(value: unknown): RemotePopupType {
  return isRemotePopupType(value) ? value : 'pa_switch';
}
